<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p52Qn1/tc-custom/9781426861536.jpg?1721442197441" alt="This image is the cover for the book Mysterious Miss M"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mysterious Miss M
      </h1>
      <p class="bookDescription body article font2">
        <p>THE REGENCY UNDERWORLD—SEX, SCANDAL AND REDEEMING LOVE<br/><br/>The Mysterious Miss M is a living male fantasy—alluring, sensual,masked. But when Lord Devlin Steele finds himself responsible for her—and her child—he comes to know the real Maddy: the loving,passionate woman who drives away the nightmares of the Waterloobattlefield.But the aristocratic soldier can't support his new family. He willinherit his fortune only on marriage to a suitable lady—and Maddyis far from suitable. With the dangers of London's underworld closingin, how can he protect the woman he has come to love?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diane Gaston
      </h2>
      
      <p class="authorDescription body article">Diane Gaston&#39;s dream job had always been to write romance novels. One day she dared to pursue that dream and has never looked back. Her books have won Romance&#39;s highest honours: the RITA Award, the National Readers Choice Award, Holt Medallion, and Golden Heart. She lives in Virginia with her husband and three very ordinary house cats. Diane loves to hear from readers and friends. Visit her website at:&#160;<a href="http://dianegaston.com">https://www.dianegaston.com/</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?702f6344